import AgenciesFilters from 'client/common/components/agencies-filters';

import './index.css';

export default AgenciesFilters;
